import React from "react";
import "./Bank.css";

const Bank = ({ selectedBank, onBankSelect, tutorials }) => {
  const getImagePath = (bank, stepNumber) => {
    try {
      return require(
        `../../assets/images/tutorials/${bank}/${bank}-step${stepNumber}.png`,
      );
    } catch (error) {
      console.warn(`Image not found for ${bank} step ${stepNumber}`);
      return null;
    }
  };

  const isLastStep = (index, steps) => {
    return index === steps.length - 1;
  };

  return (
    <div className="Bank">
      <div className="BankSidebar">
        <h3>Escolha seu banco:</h3>
        <button
          className={`BankButton ${selectedBank === "itau" ? "active" : ""}`}
          onClick={() => onBankSelect("itau")}
        >
          <img
            src={require("../../assets/images/banks/itau-icon.png")}
            alt="Itaú"
            width="24"
            height="24"
          />
          Itaú
        </button>
        <button
          className={`BankButton ${selectedBank === "nubank" ? "active" : ""}`}
          onClick={() => onBankSelect("nubank")}
        >
          <img
            src={require("../../assets/images/banks/nubank-icon.png")}
            alt="Nubank"
            width="30"
            height="30"
          />
          Nubank
        </button>
      </div>
      <div className="BankContent">
        {selectedBank ? (
          <div className="TutorialContainer">
            <h1>Conecte sua conta Vempix:</h1>
            <div className="StepsContainer">
              {tutorials[selectedBank].map((step, index) => (
                <div
                  key={index}
                  className={`Step ${isLastStep(index, tutorials[selectedBank]) ? "lastStep" : ""}`}
                >
                  <div className="StepTopLine">
                    <div className="StepNumber">{index + 1}</div>
                    <div className="StepText">{step}</div>
                  </div>
                  {getImagePath(selectedBank, index + 1) && (
                    <div className="TutorialImage">
                      <img
                        src={getImagePath(selectedBank, index + 1)}
                        alt={`Passo ${index + 1} para ${selectedBank}`}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="TutorialContainer">
            <div className="TutorialStartText">
              <h1>Bem-vindo ao Tutorial de Conexão</h1>
              <p>
                Selecione seu banco na barra lateral para visualizar o passo a
                passo de como conectar sua conta Vempix.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Bank;

